import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { Typography, TextField } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const ownerName = useSelector((state) => state.formState.Owner_name);
  const ownerPhone = useSelector((state) => state.formState.Owner_phone);
  const language = useSelector((state) => state.formState.Page_language);

  useEffect(() => {}, [language]);
  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={2} showStepper />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">{translate('Your Info')} </Typography>
          <TextField
            color="primary"
            margin="normal"
            required
            fullWidth
            id="promo"
            label={translate('Owner Name')}
            name="promo"
            autoComplete="email"
            autoFocus
            onChange={(e) => {
              // console.log(e.target.value);
              dispatch(updateState({ Owner_name: e.target.value }));
            }}
          />
          <MuiPhoneNumber
            fullWidth
            label={translate('Owner Phone *')}
            defaultCountry="us"
            onChange={(value) => {
              dispatch(updateState({ Owner_phone: value }));
            }}
          />
          <br />
          <br />
          <TransitionButtons
            disabledNext={!ownerName || ownerPhone.length !== 17}
            showBack
          />
        </BoxContentContainer>
      </MiddleLayer>

      <BottomLayer>
        <DesignAndLanguages showLanguages={false} />
      </BottomLayer>
    </ViewPortContainer>
  );
}
